import type {
  CurrencyExchangeDetailsType,
  KpiListType,
  MasterDataType,
} from "@/redux/masterData/masterTypes";

import { CategoryDetailsType } from "@/commonTypes/masterDataTypes";

export const initialState: MasterDataType = {
  branchName: "",
  branchStatus: "",
  success: null,
  error: null,
  statusCode: null,
  message: "",
  fetching: false,
  totalCount: 0,
  masterDataListing: [],
  updateBranchData: {},
  activityCode: "",
  description: "",
  activityCodeType: "",
  masterDataActivivtyCodeListing: [],
  masterDataBranchListTotal: "",
  masterDataActivityCodeListTotal: "",
  masterDataCurrencyListTotal: "",
  currencyName: "",
  currencySign: "",
  currencyShortForm: "",
  masterDataCurrencyListing: [],
  isBranchName: null,
  branchFetching: false,
  branchMessage: "",
  branchError: "",
  branchSatusCode: null,
  branchSuccess: null,
  clientGroupList: [],
  clientGroupTotalCount: 0,
  clientGroupUniqueCheckMessage: "",
  clientGroupUniqueCheckFetching: false,
  emailerList: [],
  emailListTotalCount: 0,
  holidayCalenderList: [],
  holidayCalenderTotalCount: 0,
  countryList: [],
  countryListTotalCount: 0,
  countryFetching: false,
  stateList: [],
  stateListTotalCount: 0,
  isState: null,
  stateFetching: false,
  cityList: [],
  cityListTotalCount: 0,
  cityFetching: false,
  isCity: null,
  stateListPermanentAddress: [],
  stateListTotalCountPermanentAddress: 0,
  isStatePermanentAddress: null,
  stateFetchingPermanentAddress: false,
  cityListPermanentAddress: [],
  cityListTotalCountPermanentAddress: 0,
  isCityPermanentAddress: null,
  cityFetchingPermanentAddress: false,
  currencyExchangeDetails: {} as CurrencyExchangeDetailsType,
  clientCategoryList: [],
  clientCategoryTotalCount: 0,
  userDepartmentList: [],
  userDepartmentTotalCount: 0,
  tdsDataList: [],
  tdsSingleData: {},
  skillMasterDataList: [],
  skillsMasterDataTotalCount: 0,
  scopeOfWorkList: [],
  scopeOfWorkTotalCount: 0,
  qualificationMasterDataList: [],
  qualificationMasterDataTotalCount: 0,
  tcsDataList: [],
  tcsSingleData: {},
  persistApplicationInProgress: {
    data: [],
    searchTerm: "",
    offset: 0,
    scrollTop: 0,
    scrollLeft: 0,
  },
  persistOfferAccepted: {
    data: [],
    searchTerm: "",
    offset: 0,
    scrollTop: 0,
    scrollLeft: 0,
  },
  codeFetching: false,
  codeError: "",
  codeMessage: "",
  pdfTemplateList: [],
  pdfTemplateCount: 0,
  jobTitleList: [],
  jobTitleTotalCount: 0,
  subCategoryList: [],
  subCategoryTotalCount: 0,
  categoryList: [],
  categoryTotalCount: 0,
  singleCategoryDetails: {} as CategoryDetailsType,
  // KRA / Performance Management
  kraList: [],
  kraTotalCount: 0,
  rateFetching: false,
  kpiList: null,
  kpiListTotalCount: 0,
  singleKpiDetailsData: [],
  kpiDetailsTotalCount: 0,
  // Nature of Transaction
  natureOfTransactionList: [],
  natureOfTransactionTotalCount: 0,
  // Relationship Type
  relationshipTypeList: [],
  relationshipTypeTotalCount: 0,
  // Applicable Act
  applicableActList: [],
  applicableActTotalCount: 0,
};
